import { Component, Input, ViewChild, ChangeDetectionStrategy, ViewChildren, QueryList } from '@angular/core';
import { ToolbarItem } from '../../interfaces/tool-bar-item.interface';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ItemService } from '../../../modules/items/services/item-service';
import { Cart } from '../../../core/interfaces/cart.interface';
import { CartService } from '../../services/cart.service';
import { Router } from '@angular/router';
import { INotificationService } from '../../services/inotification.service';
import { SVGIcon, saveIcon, thumbUpIcon, xIcon } from '@progress/kendo-svg-icons';
import { HttpErrorResponse } from '@angular/common/http';
import { BooleanResult } from '../../../core/interfaces/boolean-result.interface';
import { RedeploymentOrderService } from '../../../modules/redeployment-orders/services/redeployment-order.service';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { IconModule } from '@progress/kendo-angular-icons';
import { NumericTextBoxComponent, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { StackLayoutModule } from '@progress/kendo-angular-layout';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { MiscellaneousItemService } from '../../../modules/miscellaneous-items/services/miscellaneous-item-service';

@Component({
    selector: 'app-side-cart',
    imports: [ButtonModule, IconModule, NumericTextBoxModule, StackLayoutModule, DialogModule],
    providers: [RedeploymentOrderService, ItemService],
    templateUrl: './side-cart.component.html',
    styleUrls: ['./side-cart.component.css']
})
export class SideCartComponent {

  @ViewChildren('numericTextBoxes') numericTextBoxes: QueryList<NumericTextBoxComponent>;

  cartItems: any;
  miscCartItems: any;
  timedOutCartItems: any;
  timedOutCartMiscItems: any;
  inputBox: number;
  itemIndex: number;
  newQuantity: number;
  opened: boolean;
  openTimeout: boolean = false;

  dialogNo: SVGIcon = xIcon;
  dialogYes: SVGIcon = thumbUpIcon;
  dialogLoader: boolean = false;
  dialogIcon: boolean = true;
  constructor(private cartService: CartService,
              private miscCartService: MiscellaneousItemService,
              private router: Router,
              private orderService: RedeploymentOrderService,
              private notificationService: INotificationService) { }

  ngOnInit(): void {

    //The current cart items
    this.cartService.getCartItems().subscribe((data: any[]) => {
      this.cartItems = data;
    });

    this.cartService.getMiscellaneousItemCartItems().subscribe((data: any[]) => {
      this.miscCartItems = data;
    });

    this.cartService.getTimedOutCartItems().subscribe((data: any[]) => {
      this.timedOutCartItems = data;
    });

    this.cartService.getRefresh().subscribe((value: boolean) => {
      if (value) {

        this.cartService.getCartItems().subscribe((data: any[]) => {
          this.cartItems = data;
        });

        this.cartService.getMiscellaneousItemCartItems().subscribe((data: any[]) => {
          this.miscCartItems = data;
        });
      }

    })
  }

  public showCart(value: any) {
    this.cartService.showCart(null);

    var wrapper = document.getElementsByClassName('wrapper')[0];
    if (!wrapper.className.includes("opened")) {
      //remove the overlay
      var removeOverlay = document.getElementsByClassName('k-overlay')[0];
      removeOverlay.classList.remove('k-overlay');
    }
  }

  removeFromCart(value: any, itemId: number, index: number, optionId: number) {
    //we need to get the index of the list of cart items, then remove it
    this.cartService.removeCartItem(itemId, optionId);

    this.cartService.removeCartItem(itemId, optionId).subscribe((data => {
      if (data.wasSuccessful) {
        this.notificationService.show({ type: 'success', title: "Success!", description: data.message, position: { horizontal: "left", vertical: "bottom" } });
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message, position: { horizontal: "left", vertical: "bottom" } });
      }
    }));

    //remove from the cart
    var itemIndex = document.getElementById("item_" + index);
    itemIndex?.remove();
  }

  removeMiscItemsFromCart(value: any, miscellaneousItemId: number, index: number) {
    //we need to get the index of the list of cart items, then remove it
    this.cartService.removeMiscCartItem(miscellaneousItemId);

    this.cartService.removeMiscCartItem(miscellaneousItemId).subscribe((data => {
      if (data.wasSuccessful) {
        this.cartService.setRefresh(true);
        this.notificationService.show({ type: 'success', title: "Success!", description: data.message, position: { horizontal: "left", vertical: "bottom" } });
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message, position: { horizontal: "left", vertical: "bottom" } });
      }
    }));

    //remove from the cart
    var itemIndex = document.getElementById("miscItem_" + index);
    itemIndex?.remove();
  }

  saveQuantity(value: any, itemId: number, optionId: number) {
    //we need to get the item id then update the quantity
    this.cartService.updateCartItem(itemId, this.newQuantity, optionId).subscribe((data => {
      if (data.wasSuccessful) {
        this.notificationService.show({ type: 'success', title: "Success!", description: data.message, position: { horizontal: "left", vertical: "bottom" } }); //{ horizontal: "right", vertical: "bottom" }
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message, position: { horizontal: "left", vertical: "bottom" } });
      }
    }));
  }

  saveItemMiscQuantity(value: any, miscItemId: number, index: number) {
    //we need to get the item id then update the quantity

    //Grab the newest quantity
    var newQuantity = this.numericTextBoxes.toArray()[index].value;

    this.cartService.updateCartMiscItem(miscItemId, newQuantity).subscribe((data => {
      if (data.wasSuccessful) {
        this.notificationService.show({ type: 'success', title: "Success!", description: data.message, position: { horizontal: "left", vertical: "bottom" } }); //{ horizontal: "right", vertical: "bottom" }
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message, position: { horizontal: "left", vertical: "bottom" } });
      }
    }));
  }

  redirectToItemSearch(value: any) {
    var url: string = 'Item/';
    window.location.replace(url);
  }

  redirectToCheckOut(value: any) {

    //If there are items that timedout, throw the modal
    if (this.timedOutCartItems.length > 0 || this.timedOutCartMiscItems > 0) {
      this.openTimeoutDialog();
    } else if (this.cartItems.length == 0 && this.miscCartItems.length == 0) {
      //if there are no cart items and no timeout items, redirect to home
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['Checkout/']);
    }

    this.cartService.showCart(null);
    var wrapper = document.getElementsByClassName('wrapper')[0];

    if (!wrapper.className.includes("opened")) {
      //remove the overlay
      var removeOverlay = document.getElementsByClassName('k-overlay')[0];
      removeOverlay.classList.remove('k-overlay');
    }
  }

  public onChange(value: string): void { /*value: string*/
    this.newQuantity = Number(value);
  }

  openTimeoutDialog() {
    this.openTimeout = true;
  }

  closeTimeoutDialog() {
    this.openTimeout = false;
  }

  acknowledgeTimedOutItems() {
    this.orderService.acknowledgeTimeoutItems().subscribe({
      next: (res: BooleanResult) => {
        if (res.wasSuccessful) {
          //redirect Home Page
          var baseUrl = window.location.href.replace(this.router.url, '');
          window.location.replace(baseUrl);

        } else {
          var errors = res.errors;
          this.notificationService.show({ type: 'error', title: "Error!", description: res.message });
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.error.title
        }
        this.notificationService.show({ title: "Error!", type: "error", description: errorMsg ?? "Something Went Wrong!" });
      }
    });
  }
}
